export const Status = {
  LEILAO_ABERTO: {code: 1, message: 'Leilão aberto'},
  LEILAO_TIMER_ALTERADO: {code: 1099, message: 'Tempo do pregão alterado'},
  LOTE_ALTERADO: {code: 2, message: 'Lote alterado'},
  LANCE_ALTERADO: {code: 101, message: 'Lance alterado'},
  LANCE_DELETADO: {code: 102, message: 'Lance deletado'},
  LANCE: {code: 100, message: 'Lance'},
  LOTE_STATUS_UPDATED: {code: 200, message: 'Status do lote modificado'},
  LOTE_INCREMENTO_UPDATED: {code: 300, message: 'Incremento do lote modificado'},
  LOTE_RENOVAR_TEMPO: {code: 400, message: 'Renovar tempo do pregão do lote'}
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/helpers/SocketStatus.js